import React, { useState } from "react"
import axios from "axios"
const { Url, apiVersion } = configs.client
import configs from "../../../config"
import { useSelector } from "react-redux"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
import { unAuthUser } from "store/actions"
import { useDispatch } from "react-redux"

export default function TeamsInfo({
  teams,
  isloading,
  setIsLoading,
  toggleViewTeamComponents,
  team,
}) {
  const defaultTeam = teams?.defaultTeam?._id
  const UserTeam = teams?.userTeam?._id
  const [viewDefaultTeamTeam, setViewDefaultTeamTeam] = useState([])
  const [viewUserTeam, setViewUserTeam] = useState([])

  const { access, authorized } = useSelector(state => ({
    access: state.Login.userAccess,
    authorized: state.Login.authorized,
  }))

  const dispatch = useDispatch()

  const fetchUserTeamData = () => {
    setIsLoading(true)

    axios
      .get(`${Url}/${apiVersion}/teams/${UserTeam}`, {
        headers: {
          "Content-Type": "application/json; charset=utf8",
          Authorization: `Bearer ${access}`,
        },
      })
      .then(res => {
        setIsLoading(false)
        // setViewUserTeam(res.data.data.team)
        toggleViewTeamComponents(res.data.data.team)
      })
      .catch(error => {
        setIsLoading(false)
        if (error.response?.status === 401) {
          dispatch(unAuthUser())
        } else if (error.response?.status === 403) {
        } else {
          console.log(error)
        }
      })
  }
  const fetchDefaultTeamData = () => {
    setIsLoading(true)

    axios
      .get(`${Url}/${apiVersion}/teams/${defaultTeam}`, {
        headers: {
          "Content-Type": "application/json; charset=utf8",
          Authorization: `Bearer ${access}`,
        },
      })
      .then(res => {
        setIsLoading(false)
        // setViewDefaultTeamTeam(res.data.data.team)
        toggleViewTeamComponents(res.data.data.team)
        toggle()
      })
      .catch(error => {
        setIsLoading(false)
        if (error.response?.status === 401) {
          dispatch(unAuthUser())
        } else if (error.response?.status === 403) {
          console.log("error response", error)
        } else {
          console.log(error)
        }
      })
  }

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  return (
    <div className=" d-flex gap-4  justify-content-between users-setting-active">
      <div className="user-status-item p-2 px-3">
        {isloading ? (
          <p className="m-0 mb-2 fw-bold">loading...</p>
        ) : (
          <h5 className="m-0 mb-2 fw-bold font-size-22">{teams?.totalTeams}</h5>
        )}
        <p className="m-0">Total Teams</p>
      </div>

      <div
        onClick={() => {
          if (defaultTeam) {
            fetchDefaultTeamData()
          }
          toggleViewTeamComponents(viewDefaultTeamTeam)
        }}
        className="user-status-item p-2 px-3"
      >
        {isloading ? (
          <p className="m-0 mb-2 fw-bold">loading...</p>
        ) : (
          <h5 className="m-0 mb-2 fw-bold font-size-22">
            {teams?.defaultTeam?.name}
          </h5>
        )}

        <p className="m-0">Default Team</p>
      </div>

      <div
        className="user-status-item flex-end p-2 px-3"
        onClick={() => {
          if (defaultTeam) {
            fetchUserTeamData()
          }
          toggleViewTeamComponents(viewUserTeam)
        }}
      >
        {isloading ? (
          <p className="m-0 mb-2 fw-bold">loading...</p>
        ) : (
          <h5 className="m-0 mb-2 fw-bold font-size-22">
            {teams?.userTeam?.name}
          </h5>
        )}

        <p className="m-0">My Team</p>
      </div>
    </div>
  )
}
